export const conditionalColumns = (
  columns: Record<string, boolean>,
): readonly string[] =>
  Object.keys(columns).filter((column) => !!columns[column]);
